import PageTemplate from '../../components/template/PageTemplate';
import { ALIMTALK_PAGE_NAME } from '../../constants/service/app/alimtalkConstants';
import { AlimtalkSendCreateWrap } from '../../views/alimtalk/send/AlimtalkSendCreateWrap';

const AlimtalkSendCreate = () => {
  return (
    <PageTemplate pageName={ALIMTALK_PAGE_NAME.SEND_CREATE}>
      <AlimtalkSendCreateWrap />
    </PageTemplate>
  );
};

export default AlimtalkSendCreate;
